// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2xEt8","noInteraction":"EventWrapper_noInteraction__2IrZw"};